const isOutOfStock = (product) => Boolean(product?.out_of_stock);

export default isOutOfStock;
